import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_acted_against_legal_reqs_by_hiring_temporaryprobati'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_acted_against_legal_reqs_by_hiring_temporaryprobati',
  name: 'Has the facility acted against legal requirements by hiring temporary/probationary/trainee/fixed-term contract workers to avoid legal obligations?',
  description:
    "The intent of this question is to understand if the facility's hiring practices around short-term labor could be seen as the facility trying to avoid certain legal obligations. \r\r\n\r\r\nFor example, \r\r\n-if a facility chooses to hire NEW workers on probation to avoid paying for the additional benefits that come along with permanent employment, answer Yes, and/or\r\r\n\r\r\n-if the facility uses repeating fixed term contracts to avoid benefits that accrue with seniority, answer Yes.\r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.",
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ep-7',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6260,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
